export default "__VITE_ASSET__6tRiOQvl__"